import React from 'react'
import pdfIcon from 'assets/images/pdf.png'


function UploadDocument ({ items }) {
  function checkFileType (url) {
    const fileExtension = url?.image?.split('.').pop().toLowerCase()
    if (fileExtension === 'pdf') {
      return 'PDF'
    } else if (
      ['jpeg', 'jpg', 'png', 'gif', 'bmp'].includes(fileExtension)
    ) {
      return 'Image'
    } else {
      return 'Unknown'
    }
  }
  console.log('items', items)
  return (
    <>

      <div className='photos'>
        <div className='images-container pl-6 pr-4 flex flex-wrap'>
          {Array.isArray(items?.documents) && items?.documents.length > 0
            ? items?.documents?.map((val, ind) => <div className='item object-cover  m-2' key={ind}>
              {checkFileType(val) === 'Image' ? <img src={val?.image} alt='image' className='object-cover w-24 h-24' /> : checkFileType(val) === 'PDF' ? <a href={val?.image} target='_blank'  rel='noreferrer' download><img src={pdfIcon} alt='image' className='object-cover w-24 h-24' /></a> : null}
              <h3 className='m-2'>{val?.title}</h3>
            </div>)
            : 'No Documents found'}

        </div>
      </div>
    </>
  )
}

export default UploadDocument
